import Model from '@/lib/data/Model';

class Translation extends Model {
    static idProperty = 'token';

    fields = ['token', 'en_US', 'en', 'tr', 'ro', 'fr', 'es', 'de', 'pt', 'ar', 'el'];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/translation/get_by_token',
            params: ['token'],
            method: 'GET',
        },
        {
            name: 'save',
            url: '/translation/update_token',
        },
        {
            name: 'readByTranslation',
            url: '/translation/get_by_translation',
            params: ['trans', 'lang'],
            method: 'GET',
        },
    ];
}

export default Translation;
